import { Injectable } from '@angular/core';

import { Observable, Observer, Subscriber } from 'rxjs';

import * as script from './../scripts/script';

@Injectable()
export class ScriptService {
  constructor() {

  }

  public sticky() {
    script.sticky();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/script-service.ts